module.exports = __webpack_public_path__ + "static/img/ad3.1c15c15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad3.png
// module id = FT0f
// module chunks = 7